<template>
	<div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8" v-if="form">
		<div class="sm:mx-auto sm:w-full sm:max-w-sm">
			<router-link :to="{name:'landing'}">
				<img class="mx-auto w-auto"
				     src="/images/logos/haldex.png"
				     alt="Haldex"/>
			</router-link>
			<h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
				{{ message ?? $t('pages.auth.forgot_password_view.enter_your_email_and_well_send_you_a_link_to_reset_your_password') }}
			</h2>
		</div>

		<div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
			<form v-if="!message" class="space-y-6" @submit.prevent="submitForm">

				<FormGroup :label="$t('pages.auth.forgot_password_view.email_address')" :error-text="form.errors?.email">
					<InputText
							ref="email"
							v-model="form.email"
							placeholder="e.g. joe.bloggs@example.com"
					/>
				</FormGroup>

				<div>
					<Button type="submit" :label="$t('pages.auth.forgot_password_view.send_reset_link')" class="w-full"/>
				</div>
			</form>

			<p class="mt-8 text-center">
				<router-link :to="{ name: 'login' }">
					<Button :label="$t('pages.auth.forgot_password_view.go_to_login')" link/>
				</router-link>
			</p>
		</div>
	</div>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";

export default {
	components: {FormGroup},
	data() {
		return {
			form: null,
			message: null,
		}
	},
	async mounted() {
		this.form = await this.$auth.getForgotPasswordForm();
	},
	methods: {
		async submitForm() {
			try {
				const response = await this.form.submit();
				this.message = response.data.status;
			} catch (e) {
				console.log(e);
			}
		}
	},
}
</script>

<style scoped>

</style>